"use client";

import type { FC, Ref } from "react";
import { Flex, useThemeSlot } from "@huub-web/ui";

import { DefaultPageHeading } from "../../components/DefaultPageHeading/DefaultPageHeading";

export type InterestRatesHeadingTemplateProps = {
  title?: string;
  description?: string;
  ref?: Ref<HTMLDivElement>;
};

export const InterestRatesHeadingTemplate: FC<
  InterestRatesHeadingTemplateProps
> = ({ title, description, ref }) => {
  const PageHeading = useThemeSlot({
    key: "pageHeading",
    defaultComponent: DefaultPageHeading,
  });

  return (
    <Flex ref={ref} direction="column" gap="s">
      <PageHeading
        scope="interestRates"
        title={title}
        description={description}
      />
    </Flex>
  );
};
